const { h, render, Component } = require('preact');
const { Portal } = require('preact-portal');

class InactiveTradeInSSA extends Component {
  constructor(props) {
    super(props);
  }

  isFinalSale(finePrint) {
    if (finePrint != null) {
      let fine_print_down = finePrint.toLowerCase();
      if (fine_print_down.indexOf(I18n.translate('js.modules.touch_v2.final_sale')) !== -1 || fine_print_down.indexOf(I18n.translate('js.modules.touch_v2.all_sales_final')) !== -1 || fine_print_down.indexOf(I18n.translate('js.modules.touch_v2.no_refunds')) !== -1) {
        return true;
      }
    }
    return false;
  }

  getInEligibilityReason(){
    if(this.isFinalSale(this.props.orderDetails.deal.finePrint)){
      return I18n.translate("js.modules.support.inactive_trade_in.finalsale");
    }
    else if(this.props.orderDetails.groupons[0].printedAt){
      return I18n.translate("js.modules.support.inactive_trade_in.voucher_viewed");
    }
    else{
      return I18n.translate("js.modules.support.inactive_trade_in.window_closed");
    }
  }

  componentDidMount() {
    window.GIG.Tooltip.reloadBindings(document.body);
  }

  render(){
    return(
      <div class="ssa-holder">
        <a class="btn-invert ssa-button tooltip-trigger inactive-tradein" data-tooltip-id="ineligibility-reason" data-position="bottom">
          {I18n.translate("js.modules.support.trade_in")}
        </a>
        <div id="ineligibility-reason" class="tooltip">
          <div class="indicator"></div>
          <div class="tooltip-content">
            <div class="tooltip-title">{I18n.translate("js.modules.support.inactive_trade_in.not_eligible")}</div>
            <div class="tooltip-body">
              {this.getInEligibilityReason()}
            </div>
          </div>
        </div>
      </div>
    );
  };
};
module.exports = InactiveTradeInSSA;
